
'use strict';

import picturefill from 'picturefill';
import lazysizes from 'lazysizes';

import es6Promise from 'es6-promise';

import FastClick from 'fastclick';
import svgInliner from 'svg-inliner-util';

import dom from './utilities/dom';
import webFontManager from './utilities/webFontManager';
import tracker from './utilities/tracker';

import simpleModal from './widgets/simpleModal';
import bgVideo from './widgets/bgVideo';
import imageGallery from './widgets/imageGallery';
import snippetsCarousel from './widgets/snippetsCarousel';
import quotesTicker from './widgets/quotesTicker';


class App {
    constructor() {
        // console.log('app started...');
        es6Promise.polyfill();

        this.configureWebfonts();
        this.configureSvgInliner();
        this.setModalView();

        this.setTrailerTriggers();
        this.setBgVideo();
        this.setImageGallery();
        this.setCarsCarousel();
        this.setQuotesTicker();

        this.setClickTracking();

        this.configureFontsTracking('6a0851f1-1ce3-4863-b795-97786afee593');
    }

    configureWebfonts() {
        this.fontManager = webFontManager(
            ['DIN Next'],
            'thumbdrift_webfont'
        );

        this.fontManager.configureWebfonts();
    }

    setModalView() {
        let targetElem = document.querySelector('[data-modal-view]');
        if (!targetElem) { return; }
        this.modal = simpleModal(targetElem);
        this.modal.setEvents();
    }

    setTrailerTriggers() {
        document.addEventListener('click', (event) => {
            let attribute = 'data-open-trailer-modal';
            let matchedElem = dom.eventAttributeMatch(event.target, event.currentTarget, attribute);

            if (!matchedElem) {
                return;
            }

            this.modal.setContent(`
                <div class="flexible-iframe">
                    <iframe src="https://www.youtube.com/embed/71Sd-uxbX6M?rel=0&amp;showinfo=0&amp;autoplay=1&amp;modestbranding=1" frameborder="0" allowfullscreen></iframe>
                </div>
            `);

            this.modal.open();
        });
    }

    setBgVideo() {
        let targetElem = document.querySelector('[data-bg-video]');

        if (!targetElem) {
            return;
        }

        this.bgVideo = bgVideo(targetElem);
        this.bgVideo.init();
    }

    setImageGallery() {
        let targetElem = document.querySelector('[data-image-gallery]');
        if (!targetElem) { return; }
        this.aboutImageGallery = imageGallery(targetElem);
        this.aboutImageGallery.init();
    }

    setCarsCarousel() {
        let rootElem = document.querySelector('[data-cars-carousel-container]');
        if (!rootElem) { return; }

        let carouselElem = rootElem.querySelector('[data-carousel]');
        let nextBtn = rootElem.querySelector('[data-btn-next]');
        let prevBtn = rootElem.querySelector('[data-btn-prev]');

        let options = {
            wrapAround: true,
            prevNextButtons: false,
            pageDots: false
        };

        this.carsCarousel = snippetsCarousel(
            carouselElem,
            options,
            nextBtn,
            prevBtn
        );

        this.carsCarousel.init();
    }

    setQuotesTicker() {
        let rootElem = document.querySelector('[data-quotes-ticker]');

        if (!rootElem) {
            return;
        }

        this.quotesTicker = quotesTicker(rootElem, {
            timePerQuote: 4000
        });

        this.quotesTicker.start();
    }

    setClickTracking() {
        document.addEventListener('click', (event) => {
            let attribute = 'data-track-click';
            let matchedElem = dom.eventAttributeMatch(event.target, event.currentTarget, attribute);

            if (matchedElem) {
                tracker.trackEvent(
                    matchedElem.getAttribute('data-track-category'),
                    matchedElem.getAttribute('data-track-click') || 'Click',
                    matchedElem.getAttribute('data-track-label')
                );
            }
        });
    }

    onSvgInlinerError() {
        console.log('error loading svg-store');
    }

    onSvgInlinerSuccess() {
        console.log('svg-store loaded successfully');
        svgInliner.process('[data-inline-svg]');
    }

    configureSvgInliner(cacheBust) {
        cacheBust = (cacheBust) ? cacheBust : 'bust';

        svgInliner.loadStore({
            url: `img/build/svg-store/store-main.svg?${cacheBust}`,
            success: this.onSvgInlinerSuccess.bind(this),
            error: this.onSvgInlinerError.bind(this)
        });
    }

    configureFontsTracking(projectID) {
        window.MTIProjectId = projectID;
        (function() {
            var mtiTracking = document.createElement('script');
            mtiTracking.type='text/javascript';
            mtiTracking.async='true';
            mtiTracking.src=('https:'==document.location.protocol?'https:':'http:')+'//fast.fonts.net/t/trackingCode.js';
            (document.getElementsByTagName('head')[0]||document.getElementsByTagName('body')[0]).appendChild( mtiTracking );
        })();
    }
}


/***
 * kick off the app
 *
 */
var onDOMReady = function() {
    console.log('DOM ready for action!');
    FastClick.attach(document.body);
    let app = new App();
};

if (document.readyState === 'interactive' || document.readyState === 'complete') {
    onDOMReady();
} else {
    document.addEventListener('DOMContentLoaded', onDOMReady);
}





/** WEBPACK FOOTER **
 ** ./src/scripts/client/app.client.js
 **/